import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly queue: { message: string, action: string, config: any }[] = [];
  private isShowing = false;

  constructor(private readonly snackBar: MatSnackBar) { }

  private showNext() {
    if (this.queue.length === 0) {
      this.isShowing = false;
      return;
    }

    this.isShowing = true;
    const { message, action, config } = this.queue[0]; // Obtener el primer mensaje de la cola
    const snackBarRef = this.snackBar.open(message, action, config);

    snackBarRef.afterDismissed().subscribe(() => {
      this.queue.shift(); // Eliminar el primer mensaje de la cola
      this.showNext();
    });
  }

  private enqueue(message: string, action: string, config: any) {
    // Verificar si el mensaje ya existe en la cola
    if (this.queue.some(item => item.message == message)) {
      return; // No agregar el mensaje si ya existe en la cola
    }

    this.queue.push({ message, action, config });
    if (!this.isShowing) {
      this.showNext();
    }
  }

  showSuccess(message: string, title: string): void {
    this.enqueue(message, 'X', { panelClass: ['successNotification'], horizontalPosition: 'end', duration: 2000 });
  }

  showError(message: string): void {
    this.enqueue(message, 'X', { panelClass: ['errorNotification'], horizontalPosition: 'end', duration: 4000 });
  }

  showInfo(message: string): void {
    this.enqueue(message, 'X', { panelClass: ['infoNotification'], horizontalPosition: 'end', duration: 3000 });
  }

  showWarning(message: string): void {
    this.enqueue(message, 'X', { panelClass: ['warningNotification'], horizontalPosition: 'end', duration: 3000 });
  }
}